import { Box, Button, Grid, makeStyles, Theme, useMediaQuery, useTheme } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { EQuoteStatus } from "../../../api/Quote/EQuoteStatus";
import { Quote } from "../../../api/Quote/Quote";
import { FeaturePaymentDeposit } from "../../../app/consts";
import { EEventType, eventAnalytic } from "../../../app/analytics";
import { useTranslation } from "react-i18next";
import { TF } from "../../../components/typography/TF";
import { colors } from "swyft-react-core";
import { useConfig } from "../../../components/config/ConfigContext";

const QuoteTopActions = ({ quote, payNextPageLink, isAvailableSchedule }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation("ab");
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const { isFeatureEnabled } = useConfig();

  return (
    <Box>
      <Grid container justifyContent={isSmall ? "center" : "flex-start"}>
        <Grid item md={8} xs={10}>
          {isFeatureEnabled(FeaturePaymentDeposit) && quote.status === EQuoteStatus.Sent && (
            <Box>
              <Box mt={2} boxShadow={5} className={classes.fab}>
                <Button
                  component={RouterLink}
                  onClick={() => {
                    eventAnalytic.record(EEventType.PayDepositTop);
                  }}
                  to={payNextPageLink}
                  variant="contained"
                  color="secondary"
                >
                  <TF bold>
                    {isAvailableSchedule
                      ? t("quote.details.top.next", "View Available Dates")
                      : t("quote.details.top.next.pay", "Pay €{0} Deposit").replace(
                          "{0}",
                          `${quote.depositRequirement}`
                        )}
                  </TF>
                </Button>
              </Box>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default QuoteTopActions;

interface Props {
  quote: Quote;
  className?: string;
  payNextPageLink: string;
  isAvailableSchedule: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  fab: {
    "& a": {
      width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      left: 0,
      backgroundColor: colors.white,
      position: "fixed",
      bottom: 0,
      zIndex: 10000,
      padding: theme.spacing(1.5)
    }
  }
}));
